
import { isEqual } from 'lodash'
import notifications from '../notifications.js'

function createFunctions(apiCall, errorText, findCallback = undefined) {
  if (findCallback === undefined) {
    findCallback = function (id) {
      return elem => elem.id === id
    }
  }

  const _vars = {
    currApiPromise: undefined,
    currApiParams: undefined,

    getApiCallDataPromise: undefined,
    getApiCallDataCallback: undefined,

    currApiCallData: undefined,
  }

  function getApiCallFromServer(apiParams) {
    if (_vars.currApiPromise === undefined || !isEqual(apiParams, _vars.currApiParams)) {
      _vars.currApiParams = apiParams
      _vars.currApiPromise = apiCall(apiParams)
      _vars.currApiPromise
        .then(response => {
          _vars.currApiCallData = response.data
          if (_vars.getApiCallDataCallback) {
            _vars.getApiCallDataCallback()
          }
        })
        .catch(error => {
          if (errorText) {
            notifications.pushError(errorText)
          }
          notifications.pushError((error.response.data) ? error.response.data : error.toString(), error)
        })
    }
    return _vars.currApiPromise
  }

  function getApiCallData(id) {
    if (_vars.currApiCallData) {
      return Promise.resolve(getApiCallDataSync(id))
    }
    else {
      _vars.getApiCallDataPromise = new Promise((resolve) => {
        _vars.getApiCallDataCallback = function () {
          resolve(getApiCallDataSync(id))
        }
      })
      return _vars.getApiCallDataPromise
    }
  }

  function getApiCallDataSync(id) {
    if (id === undefined) {
      return _vars.currApiCallData
    }

    if (_vars.currApiCallData === undefined) {
      return undefined
    }

    // return _vars.currApiCallData.find(elem => elem.db_id === id)
    return _vars.currApiCallData.find(findCallback(id))
  }

  function getNewApiCallFromServerForce(apiParams) {
    _vars.currApiPromise = undefined
    return getApiCallFromServer(apiParams)
  }

  return [
    getApiCallFromServer,
    getApiCallData,
    getApiCallDataSync,
    getNewApiCallFromServerForce,
  ]
}

export default {
  createFunctions
}
